import { IFilterTreeGroup } from '@common/constants/filters'
import { SavedFilterTable } from '@common/interfaces/savedFilter'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'savedFilters'

export interface ISavedFilterScopeParams {
  tableKey: SavedFilterTable
  projectId?: string
}

export const [LIST_SAVED_FILTERS_REQUEST, LIST_SAVED_FILTERS_SUCCESS, LIST_SAVED_FILTERS_FAILURE] =
  createRequestTypes(prefix, 'LIST_SAVED_FILTERS')

export const listSavedFilters = createAction((params: ISavedFilterScopeParams) => ({
  type: [LIST_SAVED_FILTERS_REQUEST, LIST_SAVED_FILTERS_SUCCESS, LIST_SAVED_FILTERS_FAILURE],
  promise: (api: IApi) => api.savedFilters.list(params),
  params,
}))

export const [
  CREATE_SAVED_FILTER_REQUEST,
  CREATE_SAVED_FILTER_SUCCESS,
  CREATE_SAVED_FILTER_FAILURE,
] = createRequestTypes(prefix, 'CREATE_SAVED_FILTER')

export const createSavedFilter = createAction(
  (
    data: ISavedFilterScopeParams & {
      name: string
      filterTree: IFilterTreeGroup
    },
  ) => ({
    type: [CREATE_SAVED_FILTER_REQUEST, CREATE_SAVED_FILTER_SUCCESS, CREATE_SAVED_FILTER_FAILURE],
    promise: (api: IApi) => api.savedFilters.create(data),
  }),
)

export const [
  UPDATE_SAVED_FILTER_REQUEST,
  UPDATE_SAVED_FILTER_SUCCESS,
  UPDATE_SAVED_FILTER_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_SAVED_FILTER')

export const updateSavedFilter = createAction(
  (id: string, data: { name?: string; filterTree?: IFilterTreeGroup }) => ({
    type: [UPDATE_SAVED_FILTER_REQUEST, UPDATE_SAVED_FILTER_SUCCESS, UPDATE_SAVED_FILTER_FAILURE],
    promise: (api: IApi) => api.savedFilters.update(id, data),
  }),
)

export const [
  DELETE_SAVED_FILTER_REQUEST,
  DELETE_SAVED_FILTER_SUCCESS,
  DELETE_SAVED_FILTER_FAILURE,
] = createRequestTypes(prefix, 'DELETE_SAVED_FILTER')

export const deleteSavedFilter = createAction((id: string) => ({
  type: [DELETE_SAVED_FILTER_REQUEST, DELETE_SAVED_FILTER_SUCCESS, DELETE_SAVED_FILTER_FAILURE],
  promise: (api: IApi) => api.savedFilters.delete(id),
}))
